import React, { Component } from 'react'
import {
  TextInput,
  Breakpoints,
  LayoutRowGap,
  Layout
} from '@volkswagen-onehub/components-core'
import { TEXT_INPUT_DYNAMIC_TEXT } from 'form/store/form/constants.js'
import FormContainer from 'form/components/molecules/mFormContainer'
import { AddressContainer } from './mGoogleAddress.style'
import { validateFields } from '../../../utils'
import { VALID, INVALID, POSTAL_CODE } from 'form/store/form/constants'

class GoogleAddress extends Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()
    this.state = {
      query: '',
      addressFinderValue: '',
      browserHasAutoFilled: false,
      autoComplete: {},
      componentForm: {
        address_finder: 'long_name',
        street_number: 'long_name',
        postal_code: 'short_name',
        route: 'long_name',
        postal_town: 'long_name',
        administrative_area_level_2: 'short_name'
      }
    }
  }

  componentDidMount() {
    const { setFormElement } = this.props
    this.loadScript(
      `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&amp;sensor=false&libraries=places`,
      () => this.handleScriptLoad(this.state.query, this.myRef, setFormElement)
    )
  }

  loadScript = (url, callback) => {
    let script = document.createElement('script')
    script.type = 'text/javascript'
    if (script.readyState) {
      script.onreadystatechange = function() {
        if (
          script.readyState === 'loaded' ||
          script.readyState === 'complete'
        ) {
          script.onreadystatechange = null
          callback()
        }
      }
    } else {
      script.onload = () => callback()
    }
    script.src = url
    document.getElementsByTagName('head')[0].appendChild(script)
  }

  handleScriptLoad = (updateQuery, autoCompleteRef, setFormElement) => {
    this.setState({ query: updateQuery, ref: autoCompleteRef })
    this.setState({
      autoComplete: new window.google.maps.places.Autocomplete(
        autoCompleteRef.current,
        { types: ['geocode'], componentRestrictions: { country: 'uk' } }
      )
    })
    this.state.autoComplete.setFields(['address_components'])
    this.state.autoComplete.addListener(
      'place_changed',
      this.fillInAddress.bind(this)
    )
  }

  fillInAddress = () => {
    // Get the place details from the autocomplete object.
    const place = this.state.autoComplete.getPlace()
    this.openHiddenAddress()

    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    if (place.address_components && place.address_components.length > 0) {
      for (let i = 0; i < place.address_components.length; i++) {
        const addressType = place.address_components[i].types[0]
        if (this.state.componentForm[addressType]) {
          const val =
            place.address_components[i][this.state.componentForm[addressType]]
          document.getElementById(addressType).value = val
          const valid = val ? VALID : INVALID
          this.props.setFormElement(addressType, {
            value: val,
            valid: valid
          })
        }
      }
    }
  }

  getPattern = type => {
    /* eslint-disable no-useless-escape */
    switch (type) {
      case POSTAL_CODE:
        return /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/
      case 'route':
      case 'street_number':
        return /^[A-Za-z0-9\s]+$/
      default:
        return /^[a-zA-Z- ']+$/
    }
  }

  openHiddenAddress = () => {
    const { setGoogleAddressIsOpenTo } = this.props

    this.setState({ query: '', addressFinderValue: '' })
    setGoogleAddressIsOpenTo(true)
    // set focus on the first revealed address item
    document
      .getElementsByClassName('address-container')[0]
      .getElementsByTagName('input')[0]
      .focus()
  }

  handleKeyDown = e => {
    if (e.key === 'Enter') {
      this.openHiddenAddress()
    } else if (e.key === 'Unidentified') {
      this.setState({ browserHasAutoFilled: true })
      this.openHiddenAddress()
    }
  }

  handleAdressFinderChange = (e, field) => {
    const { googleAddressIsOpen, cmsData } = this.props
    let val = e.target.value

    // browser autocompleted the addressFinderValue
    if (googleAddressIsOpen && this.state.browserHasAutoFilled) {
      // we are open and need to clear the addressFinderValue
      val = ''
      this.setState({ browserHasAutoFilled: false })
      // browser autocomplete doesnt reckonise the hidden POSTAL_CODE field. force it here
      let field
      for (let i = 0; i < cmsData.addressFields.length; i++) {
        if (cmsData.addressFields[i].name === POSTAL_CODE) {
          field = cmsData.addressFields[i]
          break
        }
      }
      if (field) {
        document.getElementById(POSTAL_CODE).value = e.target.value
        this.props.setFormElement(POSTAL_CODE, {
          value: e.target.value,
          valid: validateFields(field, e.target.value) ? VALID : INVALID
        })
      }
    }

    this.setState({ query: e.target.value, addressFinderValue: val })
    this.props.setFormElement(field.name, {
      value: '',
      valid: VALID
    })
  }

  handleChange = (e, field) => {
    this.props.setFormElement(field.name, {
      value: e.target.value,
      valid: validateFields(field, e.target.value) ? VALID : INVALID
    })
  }

  render() {
    const { cmsData, getInputStyle, googleAddressIsOpen } = this.props
    const { addressFinderValue } = this.state
    // add regex pattern to the fields
    cmsData.addressField.pattern = this.getPattern(cmsData.addressField.name)
    const addressFieldsWithPattern = cmsData.addressFields.map(field => {
      field.pattern = this.getPattern(field.name)
      return field
    })

    return (
      <>
        <Layout
          rowGap={LayoutRowGap.static300}
          appearance={{
            [Breakpoints.default]: [{ name: 'a', columns: 24 }],
            [Breakpoints.tablet]: [
              { name: 'a', columns: 11 },
              { name: '.', columns: 13 }
            ]
          }}
        >
          <FormContainer key={cmsData.addressField.name}>
            <TextInput
              ref={this.myRef}
              value={addressFinderValue}
              onChange={e =>
                this.handleAdressFinderChange(e, cmsData.addressField)
              }
              onKeyDown={this.handleKeyDown}
              label={cmsData.addressField.label}
              placeholder={cmsData.addressField.label}
              id={cmsData.addressField.name}
              validText={cmsData.addressField.error}
              required={cmsData.addressField.required}
              errorText={cmsData.addressField.error}
              appearance={getInputStyle(
                cmsData.addressField.name,
                TEXT_INPUT_DYNAMIC_TEXT
              )}
            />
          </FormContainer>
        </Layout>
        <AddressContainer
          className={
            googleAddressIsOpen
              ? 'address-container address-container--show'
              : 'address-container'
          }
        >
          <Layout
            rowGap={LayoutRowGap.static300}
            appearance={{
              [Breakpoints.default]: [
                { name: 'a', columns: 24 },
                { name: 'b', columns: 24 }
              ],
              [Breakpoints.tablet]: [
                { name: 'a', columns: 11 },
                { name: '.', columns: 2 },
                { name: 'b', columns: 11 }
              ]
            }}
          >
            {addressFieldsWithPattern.map(cmsData => (
              <FormContainer key={cmsData.name}>
                <TextInput
                  onChange={e => this.handleChange(e, cmsData)}
                  label={cmsData.label}
                  placeholder={cmsData.placeholder}
                  id={cmsData.name}
                  key={cmsData.name}
                  validText={cmsData.error}
                  required={cmsData.required}
                  errorText={cmsData.error}
                  appearance={getInputStyle(
                    cmsData.name,
                    TEXT_INPUT_DYNAMIC_TEXT
                  )}
                />
              </FormContainer>
            ))}
          </Layout>
        </AddressContainer>
      </>
    )
  }
}

export default GoogleAddress
